import { useMutation } from "react-query";
import axios from "axios";

import { smsJoinPath, smsVerificationPath } from "./smsVerificationApiConfig";

export const useSendSmsVerification = () => {
    const sendSmsVerification = async (phone: string) => {
        const response = await axios.post(smsVerificationPath.sendSms, { phone });
        return response.data;
    };

    return useMutation({ mutationFn: sendSmsVerification });
};

// 로그인
type loginViaSmsVerificationCodeParams = {
    phone: string;
    loginType: string;
    deviceId: string;
    pushToken: string;
    domain?: string;
};

type loginViaSmsVerificationCodeResponse = {
    success: boolean;
    message?: string;
    accessToken?: string;
    refreshToken?: string;
    isExpert?: boolean;
    authCode?: string;
};

export const useLoginViaSmsVerificationCode = () => {
    const loginViaSmsVerificationCode = async (
        params: Omit<loginViaSmsVerificationCodeParams, "domain">,
    ): Promise<loginViaSmsVerificationCodeResponse> => {
        const response = await axios.post(smsVerificationPath.loginViaSms, {
            ...params,
            domain: "missgoauction.com",
        });
        return response.data;
    };

    return useMutation({ mutationFn: loginViaSmsVerificationCode });
};

// 회원가입
export type joinViaSmsParams = {
    phone: string;
    email: string;
    name: string;
    deviceId: string;
    osType: string;
    pushToken: string;
    isAgreedMarketing: boolean;
    partnerCode?: string;
};

type joinViaSmsResponse = {
    success: boolean;
    token: {
        accessToken: string;
        refreshToken: string;
    };
    productName: string;
    subscriptionExpiredAt: string;
    authCode: string;
};

export const useJoinViaSms = () => {
    const joinViaSms = async (params: joinViaSmsParams): Promise<joinViaSmsResponse> => {
        const response = await axios.post(smsJoinPath.joinViaSms, params);
        return response.data;
    };

    return useMutation({ mutationFn: joinViaSms });
};

// 인증번호 확인
export const useMatchSmsVerificationCode = () => {
    const matchSmsVerificationCode = async (params: { phone: string; code: string }) => {
        const response = await axios.post(smsVerificationPath.matchCode, params);
        return response.data;
    };

    return useMutation({ mutationFn: matchSmsVerificationCode });
};
